import { useSearchParams } from "react-router-dom";
import { DashboardGoBackButton } from "../../components/Untils/DashboardGoBackButton";
import { PaymentLinkHeaderText } from "../../components/DashBoardComponents/ContentWrapper/ContentWrapper.styles";
import { SettingsTabs } from "./SettingsTabs";
import { PaymentLinkContainer } from "../DashboardReturningUsers/DashboardReturningUsers.styles";
import snakeCase from "lodash/snakeCase";
import React from "react";
import styled from "styled-components";
import SettingContentsRender from "./contents";
import { CustomButton } from "../../components/Button/CustomButton";
const Settings = () => {
  let [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = React.useState(0);
  const tabOptions = ["Brand Settings", "Transaction Settings"].map(
    (tab, index) => ({
      index,
      label: tab,
      value: snakeCase(tab),
    })
  );
  const handleChangeTab = (data: any) => {
    setActiveTab(data.index);
    setSearchParams({ ...(data?.data ?? {}), active: data.index });
  };
  React.useEffect(() => {
    let num = Number(searchParams.get("active") || 0);
    num = tabOptions.length - 1 >= num ? num : 0;
    setActiveTab(num);
  }, [searchParams, tabOptions.length]);

  return (
    <>
      <br />

      <DashboardGoBackButton />
      <UserHeader>
        <PaymentLinkHeaderText>Payment Link Settings</PaymentLinkHeaderText>

        <Container>
          <SettingsTabs
            options={tabOptions}
            active={activeTab}
            onChange={handleChangeTab}
          />
          <br />

          <TabContent>
            <h2 className={"title"}>{tabOptions?.[activeTab]?.label}</h2>

            <div>
              {SettingContentsRender(
                activeTab,
                (handleReset, handleSubmit, { isValid }) => (
                  <ActionButtons>
                    <CustomButton
                      onClick={handleReset}
                      $outline
                      $secondary
                      id={"some-id"}
                    >
                      Cancel
                    </CustomButton>
                    <CustomButton
                      onClick={handleSubmit}
                      disabled={!isValid}
                      $secondary
                      id={"some-ids"}
                    >
                      Save changes
                    </CustomButton>
                  </ActionButtons>
                )
              )}
            </div>
          </TabContent>
        </Container>
      </UserHeader>
    </>
  );
};

const Container = styled(PaymentLinkContainer)`
  background: transparent;
  border: none;
`;
export const TabContent = styled.section`
  width: 100%;
  min-height: 300px;
  background-color: white;
  padding: 0;
  border-radius: 10px;

  @media (min-width: 1000px) {
    min-width: 900px;
  }
  @media (max-width: 700px) {
    min-width: 500px;
  }

  h2.title {
    color: #09005b;
    font-family: "GT Walsheim Pro";
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 32px;
    letter-spacing: 0.36px;
    padding: 20px;
    margin-bottom: 0px;
    border-bottom: 1px solid #e8eaed;
  }
  > div {
    padding: 10px 20px 30px;
  }
`;

const ActionButtons = styled.section`
  display: flex;
  justify-content: flex-end;
  gap: 20px;
  padding: 10px 20px 30px;
`;

const UserHeader = styled.div`
  width: 78vw;
  border-radius: 10px;
  position: relative;
  margin-bottom: 2rem;
  @media screen and (max-width: 768px) {
    width: 100%;
    height: auto;
  }
`;
export default Settings;
